export default function SkillsFooter() {
  return (
    <div className="skills-footer">
      <div className="learning-indicator">
        <span className="pulse-dot"></span>
        Always learning and growing
      </div>
    </div>
  );
}
